import arthurPic from "@/public/images/artists/arthur.png";
import { Artist } from "@/types/types";

export const arthur = {
  id: "240",
  name: "Arthur",
  image: arthurPic,
  description: `Arthur's voice has a smooth, slightly nasal timbre with a youthful, plaintive edge. His delivery is fluid and melodic, often sitting in the space between rapping and singing.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Farthur-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Unprocessed", "Pop", "RnB"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 43,
        high: 67,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
